import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BinManagement } from "./pages/BinManagement";
// import { InventoryManagement } from "./pages/InventoryManagement";
import { InwardManagement } from "./pages/InwardManagement";
import { OutwardManagement } from "./pages/OutwardManagement";
import { ReturnManagement } from "./pages/ReturnManagement";
import { ReturnDetails } from "./pages/ReturnDetails";
import { PutawayManagement } from "./pages/PutawayManagement";
import { ProductMaster } from "./pages/ProductMaster";
import { CompanyManagement } from "./pages/CompanyManagement";
import { Reports } from "./pages/Reports";
import DashboardDemo from "./pages/DashboardDemo";
import Login from "./pages/Login";
import Layout from "./components/common/Layout";
import { AuthProvider, useAuth } from "./context/AuthContext";

/** Single app-level toast container; kept mounted across route changes. No containerId = default, so all toast() calls show here. */
const AppToast = () => (
  <ToastContainer
    position="top-right"
    autoClose={false}
    hideProgressBar
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    style={{ zIndex: 999999 }}
  />
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// App Routes Component
const AppRoutes = () => {
  const { isAuthenticated, login } = useAuth();

  return (
    <>
      <AppToast />
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Login onLogin={login} />
            )
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout>
                <DashboardDemo />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <Layout>
                <ProductMaster />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inward"
          element={
            <ProtectedRoute>
              <Layout>
                <InwardManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/outward"
          element={
            <ProtectedRoute>
              <Layout>
                <OutwardManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/returns"
          element={
            <ProtectedRoute>
              <Layout>
                <ReturnManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/returns/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ReturnDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/putaway"
          element={
            <ProtectedRoute>
              <Layout>
                <PutawayManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/bins"
          element={
            <ProtectedRoute>
              <Layout>
                <BinManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/inventory"
          element={
            <ProtectedRoute>
              <Layout>
                <InventoryManagement />
              </Layout>
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/company"
          element={
            <ProtectedRoute>
              <Layout>
                <CompanyManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Layout>
                <Reports />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
